import pako from 'pako';
import { t } from 'utils/getLiteral';
import { sortByProp } from 'utils/array';

const FilterSchema = [
    {
        dataType: 'text',
        description: 'cfm_label_code_name',
        id: 'name',
    },
    {
        dataType: 'boolselect',
        description: 'cfm_label_code_status',
        id: 'published',
        inputAttrs: {
            optionLabels: {
                yes: 'cfm_label_code_published',
                no: 'cfm_label_code_draft',
            },
        },
    },
];

const CrudFields = ['code', 'description', 'documentation', 'enabled', 'name'];

export default class CustomCodesManager {
    constructor(api, s3Api) {
        this.api = api;
        this.s3Api = s3Api;
    }

    getFilterSchema = () => sortByProp(FilterSchema, 'description', t);

    getCrudFields = () => CrudFields;

    getCodes = () =>
        this.api.getCodes().then((res) => {
            const result = this.mapperCodeList(res);
            return result;
        });

    getCode = (name) => this.api.getCode(name);

    getCrudCode = (name) => {
        let fn;
        return this.api
            .getCrudCode(name)
            .then((res) => {
                fn = res;
                return this.getFunctionCode(fn.url);
            })
            .then((code) => {
                fn.code = code;
                return fn;
            });
    };

    createCode = ({ values }) => {
        const { code, ...rest } = values;
        const { name } = rest;
        return this.api
            .createFunction(rest)
            .then(() => this.uploadFunctionCode(name, code))
            .then(() => this.publishFunction(name));
    };

    updateCode = ({ values }) => {
        const { code, name, ...rest } = values;
        return this.api
            .updateFunction(name, rest)
            .then(() => this.uploadFunctionCode(name, code))
            .then(() => this.publishFunction(name));
    };

    deleteCode = (name) => this.api.deleteFunction(name);

    publishFunction = (name) => this.api.publishFunction(name);

    getInitialCrudValues = (event) => {
        const obj = event || {};
        return {
            arguments: obj.arguments || [{ field: '', type: 'string' }],
            description: obj.description || '',
            documentation: obj.documentation || '',
            name: obj.name || '',
            code:
                obj.code ||
                `\nexports.handler = (library, event, context) => {\n\n\t${t(
                    'cfm_placeholder_add_your_code_here',
                )}\n\t\n\n}`,
        };
    };

    getFunctionCode = (url) =>
        this.s3Api.getFile(url).then((compressed) => {
            return pako.inflate(compressed, { to: 'string' });
        });

    uploadFunctionCode = (name, code) =>
        this.api.getUrlToUpload(name).then((res) => {
            if (res && res.url) {
                const compressed = pako.gzip(code);
                return this.s3Api.uploadFile(res.url, compressed);
            }
            return null;
        });

    mapperCodeList = (codes) =>
        codes.map(({ params, ...code }) => ({
            ...code,
            published: code.version > -1,
        }));
}
